import { Record } from 'immutable';

export default class TimeplanUnitRecord extends Record({
  absentReason: undefined,
  booking: undefined,
  cancelledAt: undefined,
  cancelReason: undefined,
  customer: undefined,
  customerAttest: undefined,
  customerFee: undefined,
  date: undefined,
  from: undefined,
  hasOvertimePrices: undefined, // Used only be FE
  id: undefined,
  indicateHandle: undefined, // Used only be FE
  internalStatus: undefined, // Used only be FE
  invoice: undefined,
  minutes: undefined,
  originalWorkType: undefined,
  overtimeMinutes: 0,
  overtimeType: undefined,
  payment: undefined,
  profit: undefined,
  resource: undefined,
  resourceCost: undefined,
  resourceFee: undefined,
  resourceHourlyFees: undefined,
  resourceId: undefined,
  resourceReplacementModel: undefined,
  skipInvoice: undefined,
  skipPayment: undefined,
  to: undefined,
  wageSupport: undefined,
  workType: undefined,
}) {
}
